export default {
  change_to_community: "切换社区",
  entry: "词条",
  home: "首页",
  managers: "管理员",
  share: "分享",
  wiki_post: "WIKI投稿",
  talks: "社区讨论",
  wiki_notice: "WIKI公告",
  search_within_the_wiki: "WIKI内搜索",
  calendar: "活动日历",
  prev_week: "上一周",
  next_week: "下一周",
  prev_month: "上一月",
  next_month: "下一月",
  weeks: {
    mon: "一",
    tue: "二",
    wed: "三",
    thu: "四",
    fri: "五",
    sat: "六",
    sun: "七"
  },
  time_left: "剩余时间：",
  time_left2: "<span>{day}</span>天<span>{hours}</span>小时<span>{minutes}</span>分<span>{seconds}</span>秒",
  toggle_month: "月历展示",
  toggle_week: "周历展示",
  year: "年",
  mouth: "月",
  calendar_toggle1: "收起",
  calendar_toggle2: "展开",
  calendar_end: "已结束",
  official_notice: "官方公告",
  entry_update: "词条更新",
  update: "更新",
  community: "玩家社区",
  community2: "社区",
  say_something: "说点什么吧",
  send: "发布",
  all: "全部",
  posts: "帖子",
  strategy: "攻略",
  question: "提问",
  notices: "公告",
  entrys: "词条",
  views: "阅读数",
  edit: "编辑",
  history_record: "历史记录",
  favorite: "收藏",
  report: "举报",
  created_on: "创建于",
  nothing_more: "没有更多数据了",
  comments: "评论",
  comment: "评论",
  follow: "关注",
  followed: "已关注",
  fans: "粉丝",
  favorites: "收藏",
  back: "返回",
  nosign: "暂无签名",
  check_in_details: "查看详情",
  reply: "回复",
  entrys2: "个词条",
  hot_entry: "热门词条",
  cyct: "常用词条",
  gltj: "攻略推荐",
  more: "更多",
  post_details: "帖子详情",
  roll_back_to_the_version: "回滚到此版本",
  last_update: "最近更新",
  modified_to_version: "修改了{version}版本",
  friendly_link: "友情链接",
  notice_tags: {
    tag1: "情报",
    tag2: "活动",
    tag3: "更新"
  },
  login_to_post: "登录后才能发帖哦"
};
